import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function ($) {

    document.querySelectorAll('.js-subscriber-cta-form').forEach(subscriberCta => {
        const container      = subscriberCta;
        const txtTitle       = container.querySelector('.l-subscriber-cta__title');
        const buttonBlock    = container.querySelector('#footer__button');
        const toggleButton   = null !== buttonBlock ? buttonBlock.querySelector('button') : null;
        const txtLabelButton = null !== buttonBlock ? buttonBlock.querySelector('span') : null;
        const arrow          = container.querySelector('.l-subscriber-cta__icon');
        const formBlock      = container.querySelector('#footer__form-block');
        const dynamicUI      = container.querySelector('.l-subscriber-cta__dynamic');
        const form           = container.querySelector('.l-subscriber-cta__form');
        const submitButton   = container.querySelector('.js-subscribe-form-submit');
        const thankYouBlock  = container.querySelector('.l-subscriber-cta__thank-you');
        const errorBlock     = container.querySelector('.l-subscriber-cta__error');
        const tl             = gsap.timeline({ paused: true });

        if (null !== txtTitle) {
            gsap.set(txtTitle, {x: '-=100%'});
        }
        if (null !== buttonBlock) {
            gsap.set(buttonBlock, {x: '+=100%'});
        }
        if (null !== formBlock) {
            gsap.set(formBlock, {opacity: 0});
        }

        tl.to(txtTitle, {
            x: '0',
            duration: 1.2,
            ease: 'power3.inOut'
        }, 0)
            .to(buttonBlock, {
                x: '0',
                duration: 1.2,
                ease: 'power3.inOut'
            }, 0)
            .to(arrow, {
                x: '+=70',
                duration: 0.6,
                ease: 'circ.in'
            }, 0)
            .to(arrow, {
                x: '0',
                duration: 0.6,
                ease: 'power1.out'
            }, '-=0.5');

        if (null !== buttonBlock) {

            // Mouse enter event listeners
            buttonBlock.addEventListener('mouseenter', () => {
                gsap.to([txtLabelButton, arrow], { opacity: 0.4, duration: 1, ease:'power2.out' });
                gsap.to(arrow, { x: '+=30', duration: 0.8, ease:'power2.inOut' });
            });

            buttonBlock.addEventListener('mouseleave', () => {
                gsap.to([txtLabelButton, arrow], {opacity: 1, duration: 0.8, ease: 'power2.out'});
                gsap.to(arrow, {x: '0', duration: 0.8, ease: 'power1.out'});
            });
        }

        if (null !== toggleButton) {
            toggleButton.addEventListener('click', () => {
                if (!toggleButton.hasAttribute('aria-disabled')) { // If it hasn't already been clicked
                    toggleButton.setAttribute('aria-disabled', 'true');
                    formBlock.setAttribute('aria-hidden', 'false');
                    formBlock.setAttribute('aria-expanded', 'true');
                    openForm();
                }
            });
        }

        if (null !== form) {
            form.addEventListener('submit', (ev) => {
                ev.preventDefault();
                if (form.reportValidity()) {
                    submitButton.dispatchEvent(new CustomEvent('start-loading'));
                    submitForm();
                }
            });
        }

        // @note We use the native form submission to manage this
        // if (null !== submitButton) {
        //     submitButton.addEventListener('click', () => {
        //         if (!submitButton.hasAttribute('aria-disabled')) { // If it hasn't already been clicked
        //             submitButton.setAttribute('aria-disabled', 'true');
        //             submitForm();
        //         }
        //     });
        // }

        function setScrollEvent() {
            ScrollTrigger.create({
                trigger: container,
                start: 'top 85%',
                onEnter: () => tl.play(), // Play the timeline when the trigger enters
                once: true, // Runs only once
                onComplete: () => gsap.set([buttonBlock, arrow], { clearProps: 'all' })
            });
        }

        function openForm() {
            // Calculate the height required to display the form
            let tw  = txtTitle.offsetWidth; // Title width
            let matchTitleWidth = false; // Flag to determine if we need to match the form width to the title width
            if (!isMultiLineText(txtTitle)) {
                matchTitleWidth = (txtTitle.innerText.toString().length > 12); // If the title is longer than 12 characters, we will match the form width to it
                if (matchTitleWidth) form.style.maxWidth = tw.toString() + 'px';
            }

            formBlock.style.display = 'block'; // Temporary
            let fh = formBlock.offsetHeight;
            formBlock.style.display = 'none'; // Restore non-visibility

            let tlshowForm = gsap.timeline({ onComplete: () => initForm() });

            // Transition to extend the layout block height by required amount
            // Fade out and take the button out of page flow
            // Reveal the form in place of the button
            tlshowForm.fromTo(dynamicUI, { height: dynamicUI.offsetHeight }, { height: fh, duration: 0.6, ease:'power2.inOut' })
                .to(buttonBlock, { opacity: 0, duration: 0.4, onComplete: () => buttonBlock.style.display = 'none' }, 0)
                .add(() => formBlock.style.display = 'block' )
                .to(formBlock, { opacity: 1, duration: 0.9, ease: 'power1.inOut' });

            if (matchTitleWidth) {
                let resizeTimer;

                window.addEventListener('resize', () => {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(() => {
                        let currentTw = txtTitle.offsetWidth;
                        if (tw !== currentTw) {
                            form.style.maxWidth = currentTw.toString() + 'px';
                            tw = currentTw;
                        }
                    }, 250);
                });
            }
        }

        function initForm() {
            gsap.set(dynamicUI, { clearProps:'height' }); // Remove height values to restore natural DOM height
            dynamicUI.querySelector('input[type="email"]').focus(); // Give focus to email form field
            ScrollTrigger.refresh(); // Account for change in height
        }

        function submitForm() {
            let data = new FormData(form);
            $.ajax({
                url: params.ajax_url,
                data: data,
                contentType: false,
                processData: false,
                type: 'POST'
            }).then(response => {
                if ('success' === response.status) {
                    thankYouBlock.setAttribute('aria-hidden', 'false');
                    // Do the animation to collapse the layout and just display the thank you message in isolation
                    let tlshowThankyou = gsap.timeline({ onComplete: () => { 
                        gsap.set([dynamicUI, txtTitle], { clearProps:'height' });
                        ScrollTrigger.refresh(); // Account for change in height
                    }});
                    let fh  = formBlock.offsetHeight;
                    thankYouBlock.style.opacity = 0;
                    thankYouBlock.style.display = 'block'; // temporary to get height
                    let tyh = thankYouBlock.offsetHeight; // The height we will be collapsing to
                    thankYouBlock.style.display = 'none'; // Reset

                    tlshowThankyou.fromTo(dynamicUI, { height: fh }, { height: tyh, duration: 0.8, ease:'power2.inOut' })
                        .to(txtTitle, { height: 0, duration: 0.8, ease:'power2.inOut' }, 0)
                        .to([formBlock, txtTitle], { opacity: 0, duration: 0.4, onComplete: () => gsap.set([formBlock, txtTitle], { display: 'none' }) }, 0)
                        .add(() => thankYouBlock.style.display = 'block')
                        .to(thankYouBlock, { opacity: 1, duration: 0.9, ease: 'power1.inOut' });
                } else {
                    submitButton.removeAttribute('aria-disabled');
                    submitButton.removeAttribute('disabled');
                    showError(response.error ?? 'Something went wrong. Please try again.');
                }
                submitBtn.dispatchEvent(new CustomEvent('stop-loading'));
            });
        }

        function showError(error) {
            errorBlock.innerHTML ='<p>' + error + '</p>';
            gsap.set(errorBlock, { display: 'block', opacity:0 });
            let eh = errorBlock.offsetHeight; // The height we will be expanding to
            errorBlock.style.height = 0; // Set height to zero
            errorBlock.setAttribute('aria-hidden', 'false');
            errorBlock.removeAttribute('hidden');
            errorBlock.classList.add('active');
            gsap.to(errorBlock, {
                height: eh,
                opacity: 1,
                duration: 0.6,
                ease:'power2.inOut',
                onComplete: () => gsap.set(errorBlock, { clearProps:'height' })
            });
        }

        function hideError() {
            gsap.to(errorBlock, {
                height: 0,
                opacity: 0,
                duration: 0.4,
                ease:'power2.inOut',
                onComplete: () => {
                    errorBlock.innerHTML = '';
                    errorBlock.setAttribute('aria-hidden', 'true');
                    errorBlock.setAttribute('hidden', 'hidden');
                    errorBlock.classList.remove('active');
                    gsap.set(errorBlock, { clearProps:'height' })
                }
            });
        }

        function isMultiLineText(element) {
            const computedStyle = window.getComputedStyle(element);
            const lineHeight = parseFloat(computedStyle.lineHeight);
            return (element.offsetHeight >= (lineHeight * 1.5));
        }

        setScrollEvent();

    });

});